import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { normalizeOptionalText } from "utils/personOptionalFields";

export default function ClientNameButton({ person, expanded, onToggle }) {
  const name = normalizeOptionalText(person.Name) ?? "-";

  return (
    <Button
      type="button"
      variant="text"
      color="info"
      aria-label={`${expanded ? "Ocultar" : "Mostrar"} datos de ${name}`}
      aria-expanded={expanded}
      aria-controls={`client-details-${person.Id}`}
      onClick={() => onToggle(person.Id)}
      startIcon={
        <KeyboardArrowDownIcon
          sx={{ transform: expanded ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}
        />
      }
      sx={{
        p: 0,
        minWidth: 0,
        textAlign: "left",
        justifyContent: "flex-start",
        textTransform: "none",
        fontSize: "inherit",
        fontWeight: 600,
        "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
      }}
    >
      {name}
    </Button>
  );
}

ClientNameButton.propTypes = {
  person: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};
